<template>
  <div style="height:100%">
    <v-row>
      <v-col style="height:100%">
        <v-card>
          <v-card-title color="primary" style="max-height: 80px">
            <v-row dense>
              <v-col cols="8" class="title blue--text section-title"
                ><span v-if="showTitle">
                  {{ title }}
                </span></v-col
              >
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  hide-details
                  prepend-icon="mdi-magnify"
                  single-line
                  label="Search"
                ></v-text-field
              ></v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div v-if="isLoading">
              Please stand by
              <v-progress-linear
                indeterminate
                color="primary"
                class="mb-0"
              ></v-progress-linear>
            </div>
            <v-data-table
              v-if="!isLoading"
              :headers="headers"
              :items="logData"
              :search="search"
              :fixed-header="true"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              hide-default-footer
              class="elevation-1 pa-2"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.name="{ item }">
                <router-link
                  :to="getPath(item.userId, item.name, item.courseId)"
                  replace
                  >{{ item.name }}</router-link
                >
              </template>
              <template v-slot:item.definitionName="{ item }">
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 180px;"
                  >{{ item.definitionName }}</span
                >
              </template>
              <template v-slot:item.userResponse="{ item }">
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 100px;"
                  >{{ item.userResponse }}</span
                >
              </template>
              <template v-slot:item.response="{ item }">
                <span :class="getColor(item.response)" dark>{{
                  item.response
                }}</span>
              </template>
              <template v-slot:item.duration="{ item }">
                <span dark>{{ getDuration(item.duration) }}</span>
              </template>
              <template v-slot:item.timestamp="{ item }">
                <span dark>{{ getCleanDate(item.timestamp) }}</span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-subtitle style="max-height: 85px;">
            <div class="text-center pt-2">
              <v-pagination
                style="max-height: 15px;"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
            </div>
            <div class="text-end">
              <v-btn color="blue darken-1" text @click="downloadData()"
                >Download</v-btn
              >
              <v-btn
                v-if="showClose"
                color="blue darken-1"
                text
                @click="closeEvent()"
                >Close</v-btn
              >
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { csvExport, getLocalDate } from '../Constants'

export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    logData: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    csvFilename: {
      type: String,
      default: 'download',
      required: false
    },
    courseId: {
      type: Number,
      required: false,
      default: null
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 5
    },
    showClose: {
      type: Boolean,
      default: false,
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0
    }
  },
  methods: {
    getDuration(duration) {
      // if (duration == null && duration === undefined) {
      //   return '0.00.00'
      // }
      return duration
    },
    downloadData() {
      let data = []
      this.logData.forEach(element => {
        let keys = {}
        this.headers.forEach(e => {
          keys[e.value] = null
          if (element[e.value] && typeof element[e.value] == 'string') {
            keys[e.value] = element[e.value].replace(/,/g, '')
            if (e.value === 'timestamp') {
              keys[e.value] = this.getCleanDate(keys[e.value])
            }
          } else if (typeof element[e.value] === 'undefined') {
            keys[e.value] = ''
          } else {
            keys[e.value] = element[e.value]
          }
        })
        data.push(keys)
      })
      csvExport(this.headers, data, this.csvFilename)
    },
    getColor(response) {
      if (response === 'Correct') return 'green--text'
      else return 'orange--text'
    },
    getPath(agentId, name, courseId) {
      const id =
        this.courseId != null && this.courseId !== undefined
          ? this.courseId
          : courseId

      return { path: `/courses/${id}?agentId=${agentId}&agentName=${name}` }
    },
    getCleanDate(timestamp) {
      return getLocalDate(timestamp).format('YYYY-M-D h:mm:ss A')
    },
    closeEvent() {
      this.$emit('closeEvent')
    }
  }
}
</script>

<style></style>
